/**
 * Landing helpers. Prefer values from GET /config/trial (tokensPerDoc).
 * Fallback matches k8s env PRETTIFAI_TOKENS_PER_DOC default.
 */
export const TOKENS_PER_COIN = 1000;
export const DEFAULT_TOKENS_PER_DOC = 3750;

export function tokensToCoins(tokens: number): number {
  return (Number.isFinite(tokens) ? tokens : 0) / TOKENS_PER_COIN;
}

export function tokensIncludedForDocs(
  docsIncluded: number,
  tokensPerDoc: number = DEFAULT_TOKENS_PER_DOC,
): number {
  const tpd = Number.isFinite(tokensPerDoc) && tokensPerDoc > 0 ? tokensPerDoc : DEFAULT_TOKENS_PER_DOC;
  return Math.max(0, Math.floor(docsIncluded)) * tpd;
}

export function coinsIncludedForDocs(
  docsIncluded: number,
  tokensPerDoc: number = DEFAULT_TOKENS_PER_DOC,
): number {
  return tokensToCoins(tokensIncludedForDocs(docsIncluded, tokensPerDoc));
}

export function approxDocsMin(docsIncluded: number): number {
  return Math.floor(Math.max(0, docsIncluded) * 0.9);
}

export function formatCoins(n: number): string {
  if (!Number.isFinite(n)) return '0';
  return Number.isInteger(n) ? n.toLocaleString() : n.toLocaleString(undefined, { maximumFractionDigits: 2 });
}
